/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, forwardRef, input, signal } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { PlaceAutocompleteComponent } from '../place-autocomplete/place-autocomplete.component';
import { LocationDtoModel } from '@well/delivery-libs/location-management/domain';

@Component({
  selector: 'well-location-autocomplete',
  standalone: true,
  templateUrl: './location-autocomplete.component.html',
  styleUrls: ['./location-autocomplete.component.scss'],
  imports: [PlaceAutocompleteComponent, ReactiveFormsModule, FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LocationAutocompleteComponent),
      multi: true,
    }
  ],
})
export class LocationAutocompleteComponent implements ControlValueAccessor {
  label = input<string>('');
  disabled = input<boolean>(false);
  required = input<boolean>(false);
  value = signal<{ description: string }>({ description: '' });
  private _onChange: any | undefined = undefined;

  writeValue(location: LocationDtoModel): void {
    if (location && location.name) {
      this.value.set({ description: location.name });
    }else{
      this.value.set({ description: '' });
    }
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {}

  onValueChange(location: { description: string }): void {
    this.value.set(location);
    this._onChange(location);
  }
}
